import React from "react";
import {buildGarrisonFiscalizationRows} from "../utils/dispatch-audit-utils.js";

const GarrisonFiscalizationContent = ({garrison, isUpdate = false}) => {
    if (!garrison) return null;

    const valueCellClassName = "break-all! whitespace-normal";
    const rows = isUpdate ? [] : buildGarrisonFiscalizationRows(garrison);

    if (isUpdate) {
        const newRows = buildGarrisonFiscalizationRows(garrison?.new);
        const oldRows = buildGarrisonFiscalizationRows(garrison?.old);
        const labels = [...new Set([...newRows, ...oldRows].map(row => row.label))];

        labels.forEach(label => {
            rows.push({
                label,
                newValue: newRows.find(row => row.label === label)?.value ?? "",
                oldValue: oldRows.find(row => row.label === label)?.value ?? ""
            });
        });
    }

    if (!rows.length) return null;

    return (
        <tr className="bg-white garrison-fiscalization-content-table">
            <td colSpan={isUpdate ? 3 : 2} className={'transform -translate-x-[8px]'}>
                <table className="w-full">
                    <thead>
                        <tr className="text-left">
                            <th colSpan={isUpdate ? 3 : 2}>Fiscalizar a guarnição</th>
                        </tr>
                    </thead>
                    <tbody>
                        { rows.map((row, index) => (
                            <tr key={`${row.label}-${index}`} className="text-left">
                                <td style={{width: "30%"}}>{row.label}</td>
                                <td className={valueCellClassName} style={{width: isUpdate ? "35%" : "70%"}}>
                                    {isUpdate ? row.newValue : row.value}
                                </td>
                                {isUpdate && (
                                    <td className={valueCellClassName} style={{width: "35%"}}>
                                        {row.oldValue}
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default GarrisonFiscalizationContent;